import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

function InterviewCard({
  numberOfInterviews,
  title,
  image,
  backgroundColor = "#fff",
  textColor = "#3f51b5",
  titleColor = "#fff",
}) {
 
  
  
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 1,
        backgroundColor: backgroundColor,
        width: "100%",
        borderRadius: "8px",
        marginBottom: 2,
      }}
    >
      <img
        src={image}
        alt="Interview"
        style={{
          width: 50,
          height: 60,
          marginRight: 20,
        }}
      />

      <CardContent sx={{  }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: titleColor ,fontSize:"16px"}}>
          {title}
        </Typography>
        {/* <br /> */}
        <Typography variant="h5" sx={{ fontWeight: "bold", color: textColor,fontSize:"16px" }}>
          {numberOfInterviews}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default InterviewCard;
